<template>
    <div>电子商务数据收集清洗</div>
</template>

<script>
    export default {
        name: "ECommerceData"
    }
</script>

<style scoped>

</style>